import * as React from "react";
// import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";

import "../../styles/Layout/_ToastMessage.scss";
import { AuthContext } from "../../context/AuthContext";

export default function ToastMessage() {

  const { toastState, setToastState } = React.useContext(AuthContext)

  const handleClose = () => {
    setToastState((prev) => (
      { ...prev, open: false }
    ))
  }

  const { open, vertical, horizontal, seconds, msg }=toastState

  return (
    <div className="toast-message">
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={seconds}
        onClose={handleClose}
        message={msg}
        key={vertical + horizontal}
      />
    </div>
  );
}
